// Single source of truth for pipeline stages (mirrors backend shared.py PIPELINE_STAGES).
export const PIPELINE_STAGES = [
  { value: "orbis_total", label: "Orbis Total" },
  { value: "succession_possible", label: "Succession Possible" },
  { value: "ai_reviewed", label: "OLTA TAM (AI Reviewed)" },
  { value: "olta_reviewed", label: "Under OLTA Review" },
  { value: "olta_approved", label: "OLTA Approved" },
  { value: "outreach_wip", label: "Outreach WIP" },
  { value: "contacted", label: "Contacted" },
  { value: "response_received", label: "Response Received" },
  { value: "first_call_meeting", label: "First Call / Meeting" },
  { value: "nda", label: "NDA" },
  { value: "on_site", label: "On-Site" },
  { value: "loi_signed", label: "LOI Signed" },
  { value: "due_diligence", label: "Due Diligence" },
  { value: "signing", label: "Signing" },
  { value: "closing", label: "Closing" },
  { value: "passed", label: "Passed" },
];

export const STAGE_LABELS = PIPELINE_STAGES.reduce((m, s) => { m[s.value] = s.label; return m; }, {});
export const STAGE_ORDER = PIPELINE_STAGES.map(s => s.value);
export const PRE_REVIEW_STAGES = ["orbis_total", "succession_possible", "ai_reviewed"];

// Broker-process funnel stages for brokered deals (mirrors backend BROKERED_FUNNEL).
export const BROKERED_STAGES = [
  { value: "deal_review", label: "Deal under Review" },
  { value: "nda_signed", label: "NDA Signed" },
  { value: "mgmt_meeting", label: "Management Meeting" },
  { value: "due_diligence", label: "Due Diligence" },
  { value: "signed", label: "Signed" },
  { value: "closed", label: "Closed" },
];
